/**
 * Po Git sync / commit / odložení / CI se musí překreslit VŠECHNY panely
 * workspace, ne jen ten, který akci spustil. Jinak lišta s SHA, worker
 * a strom souborů drží starý stav.
 */
import type { QueryClient } from '@tanstack/react-query';

const KEYS = [
  'codable-project',
  'phone-codable-project',
  'codable-project-status',
  'workspace-work',
  'gitlab-ci-status',
  'gitlab-worker-resolve',
  'orchestrator-project-operations',
  'codable-tree',
  'codable-file',
  'codable-project-chat-context',
  // Okno Publikace: sloty karuselu a seznam commitů v pásce.
  'apphost-release-carousel',
  'gitlab-commits-tape',
] as const;

export function refreshCodableWorkspace(
  qc: QueryClient,
  opts?: { slug?: string | null; preview?: boolean },
): void {
  for (const key of KEYS) {
    void qc.invalidateQueries({ queryKey: [key] });
  }
  if (opts?.preview === false) return;
  try {
    window.dispatchEvent(
      new CustomEvent('codable:preview-refresh', {
        detail: { slug: opts?.slug ?? undefined },
      }),
    );
  } catch {
    /* ignore */
  }
}
